import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import api from "../../core/axios/axiosInstance";
import { fetchProfile } from "../../core/data/redux/slices/ProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const route = all_routes;
  const dispatch = useDispatch();

  // Standard login states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Magic link states
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [magicEmail, setMagicEmail] = useState("");
  const [magicLink, setMagicLink] = useState("");
  const [magicLoading, setMagicLoading] = useState(false);
  const [magicMessage, setMagicMessage] = useState("");
  const [showResend, setShowResend] = useState(false);
const [resendLoading, setResendLoading] = useState(false);

  const fetchUserError = useSelector((state) => state.profile.error);


  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !fetchUserError) {
      navigate(route.dashboard);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const unlocked = params.get("unlocked");
    if (unlocked === "success") {
      setMessage("Your account has been unlocked. You can now log in.");
    } else if (unlocked === "error") {
      const reason = params.get("reason");
      if (reason === "expired") {
        setMessage("Unlock link has expired. Please try logging in again to receive a new link.");
      } else if (reason === "token_used_or_invalid") {
        setMessage("This unlock link has already been used or is invalid.");
      } else {
        setMessage("Invalid unlock link. Please try logging in again.");
      }
    }
  }, [location.search]);



  const handleLogin = async (e) => {
    e.preventDefault()
    setMessage("");
    setIsLoading(true);
    const payload = { email, password };

    try {
      const payload = { email, password };

      const response = await api.post("user/login", payload);
      // const response = await axios.post("https://nf6fp9tcn6.execute-api.eu-north-1.amazonaws.com/user/login", payload);
      // const response = await axios.post("http://localhost:4004/user/login", payload);


      if (response.data.status === "success") {
        localStorage.setItem("token", response.data.data.token);
        setMessage(response.data.message);

        await dispatch(fetchProfile());

        // Fire-and-forget: save device/browser session info
        api.post("/user-session/save", {
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          viewportWidth: window.innerWidth,
          viewportHeight: window.innerHeight,
          pixelRatio: window.devicePixelRatio,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          language: navigator.language,
        }).catch(() => {});

        if (response.data.data.role === "superadmin") {
          navigate(route.adminCompaniesList);
        } else {
          navigate(route.dashboard);
        }
      }
  
    }catch (error) {
  console.log(error?.response?.data, "error");

  const status = error?.response?.status;
  const errorMessage = error?.response?.data?.message || "";

  // 👇 detect unverified email case
  if (status === 403 && errorMessage.toLowerCase().includes("verify")) {
    setShowResend(true);
  } else {
    setShowResend(false);
  }

  setMessage(errorMessage || "Login failed");
}
     finally {
      setIsLoading(false);
    }
  };


const handleResendVerification = async () => {
  setResendLoading(true);
  // setMessage("");

  try {
    const res = await api.post("user/resendVerificationLink", {
      email,
    });

    setMessage(res.data.message || "Verification link sent!");
  } catch (error) {
    setMessage(
      error?.response?.data?.message || "Failed to resend verification link"
    );
  } finally {
    setResendLoading(false);
  }
};  
  const handleSendMagicLink = async () => {
    setMagicLoading(true);
    setMagicMessage("");

    try {

      const res = await api.post("/user/generateMagicLink", {
        email: magicEmail,
      });


      setMagicMessage(res.data.message || "Magic link sent!");
      setShowEmailModal(false);
      setShowLinkModal(true);
    } catch (error) {
      setMagicMessage(
        error?.response?.data?.message || "Unable to send magic link."
      );
    } finally {
      setMagicLoading(false);
    }
  };

  const handleVerifyMagicLink = async () => {
    setMagicLoading(true);
    setMagicMessage("");

    try {
      const res = await api.post("/user/login/magic-link", { magicLink });

      localStorage.setItem("token", res.data.data.token);

      await dispatch(fetchProfile());

      // Fire-and-forget: save device/browser session info
      api.post("/user-session/save", {
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        pixelRatio: window.devicePixelRatio,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language: navigator.language,
      }).catch(() => {});

      navigate(route.dashboard);
    } catch (error) {
      setMagicMessage(
        error?.response?.data?.message || "Invalid magic link."
      );
    } finally {
      setMagicLoading(false);
    }
  };

  return (
    <div className="account-content">
      <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden">
        <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
          <form className="flex-fill" onSubmit={handleLogin}>
            <div className="mx-auto mw-450">

              <div className="text-center mb-4">
                <Link to={"https://voycell.com"}>
                  <ImageWithBasePath
                    src="assets/img/voycell-logo.webp"
                    className="img-fluid"
                    alt="Logo"
                  />
                </Link>
              </div>

              <div className="mb-4">
                <h4>Sign In</h4>
                <p>Access the VOYCELL panel using your email and passcode.</p>
              </div>

              <div className="mb-3">
                <label>Email Address</label>
                <div className="position-relative">
                  <span className="input-icon-addon">
                    <i className="ti ti-mail"></i>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="john.doe@example.com"
                    required
                  />
                </div>
              </div>

              <div className="mb-3">
                <label>Password</label>
                <div className="pass-group">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    className="pass-input form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="*********"
                    required
                  />
                  <span
                    className={`ti toggle-password ${isPasswordVisible ? "ti-eye" : "ti-eye-off"
                      }`}
                    onClick={togglePasswordVisibility}
                  ></span>
                </div>
              </div>

              {/* {message && (
                <div
                  className={`alert ${message.toLowerCase().includes("success")
                      ? "alert-success"
                      : "alert-danger"
                    }`}
                >
                  {message}
                </div>
              )} */}

{message && (
  <div
    className={`d-flex justify-content-between align-items-center alert ${
      message.toLowerCase().includes("success")
        ? "alert-success"
        : "alert-danger"
    }`}
  >
    {message}

    {showResend && (
      <div>
        <button
          type="button"
          className="btn btn-warning btn-sm"
          onClick={handleResendVerification}
          disabled={resendLoading}
        >
          {resendLoading ? "Sending..." : "Resend"}
        </button>
      </div>
    )}
  </div>
)}
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="form-check form-check-md">
                  <input className="form-check-input" type="checkbox" defaultChecked />
                  <label>Remember Me</label>
                </div>

                <Link to="/forgot-password" className="text-primary fw-medium">
                  Forgot Password?
                </Link>
              </div>

              <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Signing In...
                  </>
                ) : (
                  "Sign In"
                )}
              </button>

              <div className="text-center my-3">or</div>

              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={() => setShowEmailModal(true)}
              >
                Login with Magic Link
              </button>

              <div className="mt-3">
                <h6>
                  New on our platform?
                  <Link to="/register" className="text-purple"> Create an account</Link>
                </h6>
              </div>

              <div className="text-center mt-4">
                <p className="fw-medium text-gray">Copyright © 2026 - VOYCELL</p>
              </div>
            </div>
          </form>
        </div>

        <div className="w-50 vh-100 account-bg-01"></div>
      </div>

      {showEmailModal && (
        <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Enter Your Email</h5>
                <button className="btn-close" onClick={() => setShowEmailModal(false)} />
              </div>

              <div className="modal-body">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control mb-3"
                  value={magicEmail}
                  onChange={(e) => setMagicEmail(e.target.value)}
                />

                <button
                  className="btn btn-primary w-100"
                  onClick={handleSendMagicLink}
                  disabled={magicLoading}
                >
                  {magicLoading ? "Sending..." : "Send Magic Link"}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {showLinkModal && (
        <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Paste Magic Link</h5>
                <button className="btn-close" onClick={() => setShowLinkModal(false)} />
              </div>

              <div className="modal-body">
                <label className="mb-2">Magic Link</label>
                <textarea
                  className="form-control mb-3"
                  rows="3"
                  value={magicLink}
                  onChange={(e) => setMagicLink(e.target.value)}
                />

                {magicMessage && (
                  <div className="alert alert-info">{magicMessage}</div>
                )}

                <button
                  className="btn btn-success w-100"
                  onClick={handleVerifyMagicLink}
                  disabled={magicLoading}
                >
                  {magicLoading ? "Verifying..." : "Verify & Login"}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Login;
